export default {
  errorsRootKey: 'phoneNumberProviders',
  resource: 'phoneNumberProviders',
  actions: ['index']
}
